// extracted by mini-css-extract-plugin
export default {"item_bold":"styles_item_bold__kRqOC"};